import { render, staticRenderFns } from "./BarChatHeader.vue?vue&type=template&id=16f68570&scoped=true"
import script from "./BarChatHeader.vue?vue&type=script&lang=ts"
export * from "./BarChatHeader.vue?vue&type=script&lang=ts"
import style0 from "./BarChatHeader.vue?vue&type=style&index=0&id=16f68570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f68570",
  null
  
)

export default component.exports